module.exports = __webpack_public_path__ + "static/4-aeae0b1e0839c68fff1f0111498157a0.jpg";